export class MenuConfig {
  clickMode = 'hover';
  nestedItems = '';
  delayShow = '';
  delayHide = '100';
  animation = 'uk-animation-slide-top-small';
  animationDuration = 300;
  offset = '';
  layout = '';
  openSocialInNewWindow = true;
}
